import { WifExternalAuthConfig } from "~/operations";

export function formatBindingConfig(config: WifExternalAuthConfig | null) {
  const { __typename, ...configToDisplay } = config || {};

  return JSON.stringify(configToDisplay, null, 4);
}
